<template>
  <div class="quick-access col-lg-6 alpha omega" v-if="items.length>0">
    <list-groups :options="options">

      <small slot="action" class="text-muted">
        {{ pagination.total }}
      </small>

      <b-list-group-item
        slot="card"
        v-for="item in items"
        :key="item.id" :href="options.link.href + item.id || '#!'"
        :target="options.link.target || '_self'"
        class="flex-column align-items-start">

        <div class="d-flex w-100 justify-content-between">

          <h5 class="mb-1">
            {{ item.name || 'Anónimo' }}
          </h5>

          <small v-if="item.created_at">
            {{ item.created_at | moment('DD/MM/YYYY HH:mm') }}
          </small>

        </div>

        <p class="mb-1" v-if="item.presentation">
          {{ item.career || 'Sem Carreira' }}<br/>
          {{ item.presentation | truncate(100) }}
        </p>

        <small v-if="item.city && item.city.representation">
          {{ item.city.representation }}
        </small>

        <div v-if="item.file.length > 0">
          <i class="fa fa-paperclip"></i> Currículo Anexado
        </div>

      </b-list-group-item>

    </list-groups>
  </div>
</template>

<script>
import { resolveHTTP } from '@/services/api'

export default {
  name: 'widget-bl-career-contacts',
  data () {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos Currículos enviados',
        icon: 'fa fa-briefcase',
        colSize: 12,
        entity: {
          url: '/bl/career-contacts',
          params: {
            per_page: 5,
            _order: 'id:desc'
          }
        },
        link: {
          href: '/#/bl-career-contacts/',
          target: '_self'
        }
      }
    }
  },

  methods: {
    refresh () {
      let self = this
      resolveHTTP(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },
  created () {
    this.refresh()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Bl/CareerContacts.vue